var map = {
	"./drh5_title_en.png": "312f",
	"./drh5_title_jp.png": "20fc",
	"./drh5_title_kr.png": "5d0d",
	"./drh5_title_sc.png": "6eac",
	"./drh5_title_tc.png": "d195"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "85c9";